// export const getRoleFromStorage = () => {
//   const raw = localStorage.getItem("USER_ROLE_ID");

//   try {
//     const parsed = JSON.parse(raw);

//     if (Array.isArray(parsed)) return parsed.map(Number);
//     if (typeof parsed === "object") return Number(parsed?.ROLE_ID);
//     return Number(parsed);
//   } catch {
//     return Number(raw);
//   }
// };
export const getRoleFromStorage = () => {
  // ── Dev/Test override ──────────────────────────────
  const override = localStorage.getItem("dev_role_override");
  if (override) return Number(override);
  // ──────────────────────────────────────────────────

  const raw = localStorage.getItem("USER_ROLE_ID");
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.map(Number);
    if (typeof parsed === "object") return Number(parsed?.ROLE_ID);
    return Number(parsed);
  } catch {
    return Number(raw);
  }
};